import React from 'react';
import { FaLinkedin } from 'react-icons/fa';
import { FaGithub } from 'react-icons/fa';
import LogoFooter from './../../assets/LogoFooter.png';

import './Footer.css';


const Footer = () => {
    
    const linkedin = "https://www.linkedin.com/in/sean-pourgoutzidis/";
    const github = "https://github.com/seanpourgoutzidis";

    return (
        <footer>
            <a href = {linkedin} target = "_blank" rel="noreferrer">
                <FaLinkedin size = {70} />
            </a>
            <img src={LogoFooter} alt="logo" />
            <a href = {github} target = "_blank" rel="noreferrer">
                <FaGithub size = {70} />
            </a>

        </footer>
    );

    // return (
    //     <div className = "bg-hoverGreen h-fit w-full">
    //         <div className = "flex justify-center">
    //             <div className = "w-2/3 h-4 border-b-4 border-darkGreen"></div>
    //         </div>

    //         <div className = "grid grid-cols-3 divide x">
    //             <a style={{color: '#152614'}} href = {linkedin} target = "_blank" className = "hidden py-4 md:py-4 px md:px-10 md:flex justify-center">
    //                 <FaLinkedin size = {70} />
    //             </a>

    //             <a style={{color: '#152614'}} href = {linkedin} target = "_blank" className = "md:hidden py-4 px flex justify-center">
    //                 <FaLinkedin size = {40} />
    //             </a>

    //             <div className = "mt-3 md:py-4 md:px-10 text-center items-center">
    //                 <div className = "text-md md:text-2xl text-darkGreen font-sora">
    //                     Sean Pourgoutzidis
    //                 </div>

    //                 <div className = "hidden pt-2 text-xs md:text-xl text-center text-black font-sora">
    //                     sean.pourgoutzidis@yahoo.ca
    //                 </div>
    //             </div>

    //             <Link to = "Home" spy={true} smooth={true} offset={-70} duration={500} className = "hidden cursor-pointer py-4 md:py-4 px md:px-10 md:flex justify-center">
    //                 <div style={{color: '#152614'}} className = "flex items-center text-3xl text-neutral text-center">
    //                     <FaArrowCircleUp size = {70}/>
    //                 </div>
    //             </Link>

    //             <Link to = "Home" spy={true} smooth={true} offset={-70} duration={500} className = "md:hidden cursor-pointer py-4 px flex justify-center">
    //                 <div style={{color: '#152614'}} className = "">
    //                     <FaArrowCircleUp size = {40}/>
    //                 </div>
    //             </Link>
    //         </div>
    //     </div>
    // );
};

export default Footer;